import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import * as React from "react";
import {AdminBannerBox} from "./boxes/admin-banner-wrapper.box";


declare global {
    namespace JSX {
        interface IntrinsicElements {
            "banner-888": any;
        }
    }
}

export interface AdminBannerComponentProps {
    bannerAdminPlaceholderId: string;
}


export class AdminBannerComponent extends OrbitComponent<AdminBannerComponentProps> {
    render() {
        const bannerSegmentation = JSON.stringify(this.services.adminBanner.getSegmentationsForAdminBanner());
        const bannerConfig = JSON.stringify(this.services.adminBanner.getConfigForAdminBanner(this.props.bannerAdminPlaceholderId));
        return (
            <AdminBannerBox>
                <banner-888
                    config={bannerConfig}
                    segmentation={bannerSegmentation}
                ></banner-888>
            </AdminBannerBox>
        );
    }
}